import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';

export const consts = createReqConsts('board', 'reqAllUsers', [
  'CLEAR',
  'CLEAR_STATUS',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'get',
  slug: [
    {
      type: 'payload.query',
      queryParameter: 'query',
      selector: 'query',
    },
    {
      type: 'payload.query',
      queryParameter: 'excluded_ids',
      selector: 'ids',
    },
    {
      type: 'payload.query',
      queryParameter: 'type',
      selector: 'type',
    },
    {
      type: 'payload.query',
      queryParameter: 'context_user_id',
      selector: 'userId',
    },
    {
      type: 'payload.query',
      queryParameter: 'practice_context_user_id',
      selector: 'contextUserId',
    },
    {
      type: 'payload.query',
      queryParameter: 'excluded_chatroom_id',
      selector: 'channelId',
    },
    {
      type: 'payload.query',
      queryParameter: 'limit',
      selector: 'limit',
    },
    {
      type: 'payload.query',
      queryParameter: 'team_search',
      selector: 'teamSearch',
    },
    {
      type: 'payload.query',
      queryParameter: 'dashboard_provider_search',
      selector: 'dashboardProviderSearch',
    },
  ],
});

const reqReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { type } = action;

  switch (type) {
    case consts.CLEAR:
      return initialState;
    case consts.CLEAR_STATUS:
      return {
        ...state,
        succeed: null,
        sending: false,
      };
    default:
      return reqReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/board/reqAllUsers.js